
angular.module('bmsApp.training').controller('TrainingCourseModalFormCtrl', [
	'$log',
	'$scope',
	'$q',
	'$modalInstance',
	'$ngBootbox',
	'EmployeeOptionsSvc',
	'TrainingProviderSvc',
	'TrainingCourseSvc',
	'training_course',
	function (
		$log,
		$scope,
		$q,
		$modalInstance,
		$ngBootbox,
		EmployeeOptionsSvc,
		TrainingProviderSvc,
		TrainingCourseSvc,
		training_course) {

		var trainingCourseOptionsPromise = TrainingCourseSvc.options();
		var employeeOptionsPromise = EmployeeOptionsSvc.employee();
		var trainingProviderOptionsPromise = TrainingProviderSvc.options();
		var promises = [trainingCourseOptionsPromise, employeeOptionsPromise, trainingProviderOptionsPromise];
		$scope.loading = true;
		$scope.processing = false;
		$q.all(promises).then(function (responses) {
			$scope.training_course = angular.copy(training_course);
			$scope.trainingCourseOptions = responses[0].data.options;
			$scope.internalTrainingProviderOptions = responses[1].data.options;
			$scope.externalTrainingProviderOptions = responses[2].data.options;
			$scope.loading = false;
		}, function (error) {
			$log.error(error);
		});

		$scope.formvalidatorconfig = {
			submitHandler: function (form) {
				$scope.submit($scope.training_course);
			},
			errorPlacement: function (error, element) {
				error.appendTo('#training-course-errors');
			},
			errorContainer: '#training-course-errors'
		};

		$scope.trainingCourseSelected = function (selected_training_course) {
			$scope.training_course = angular.copy(selected_training_course);
		};

		$scope.submit = function (training_course) {
			$scope.processing = true;
			var modalResult = {};
			var savePromise = training_course.id ? TrainingCourseSvc.update(training_course.id, training_course) : TrainingCourseSvc.create(training_course);
			savePromise
				.then(function (response) {
					modalResult.success = response.data.success;
					modalResult.action = training_course.id ? 'update' : 'create';
					modalResult.training_course = training_course;
					$modalInstance.close(modalResult);
				}, function (error) {
					modalResult.error = error;
					$modalInstance.close(modalResult);
				})
				.finally(function () {
					$scope.processing = false;
				});
		};

		$scope.delete = function (training_course) {
			$ngBootbox.confirm('Are you sure you want to do this?')
				.then(function () {
					var modalResult = {};
					TrainingCourseSvc.delete(training_course.id)
						.then(function (response) {
							modalResult.success = response.data.success;
							modalResult.action = 'delete';
							$modalInstance.close(modalResult);
						}, function (error) {
							modalResult.error = error;
							$modalInstance.close(modalResult);
						});
				});
		};

		$scope.cancel = function () {
			$modalInstance.dismiss('cancel');
		};

	}]);
